// extracted by mini-css-extract-plugin
module.exports = {"timeslot-btn":"TimeslotButton_timeslot-btn__1UcMl","timeslot-btn--modal":"TimeslotButton_timeslot-btn--modal__35iJh"};